import * as Sentry from '@sentry/nextjs';
import { SCHEDULE_DATE_FORMAT } from '@/widgets/FindAClass/classfinder.constants';
import dayjs from '@/common/lib/dayjs';
import proxyClient from '@/common/lib/proxyClient';
import { ClassScheduleResponse } from '@/widgets/FindAClass/classfinder.interfaces';

interface FetchClassScheduleParams {
  clubId: number;
  lang: string;
  start_date: string;
  end_date: string;
  signal?: AbortSignal;
}

export const fetchClassSchedule = async ({
  lang,
  start_date,
  end_date,
  clubId,
  signal,
}: FetchClassScheduleParams) => {
  try {
    const { data } = await proxyClient.get('/frontend/class_schedule', {
      params: {
        venue_id: clubId,
        start_date: dayjs(start_date).format(SCHEDULE_DATE_FORMAT),
        end_date: dayjs(end_date).format(SCHEDULE_DATE_FORMAT),
        language: lang,
      },
      headers: {
        'Accept-Language': lang,
      },
      signal,
    });

    return data as ClassScheduleResponse;
  } catch (error: any) {
    if (error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
      console.log('Fetch class schedule cancelled');
      return null;
    }

    Sentry.captureException(error);
    console.warn('Error fetching class schedule:', error);
    return null;
  }
};
